(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/widgets/match-ticker/views/match-score.js') >= 0) return;  svs.modules.push('/widgets/match-ticker/views/match-score.js');
(function(svs, Handlebars) {
_svs=window.svs=window.svs||{};
_svs.widget=_svs.widget||{};
_svs.widget.match_ticker=_svs.widget.match_ticker||{};
_svs.widget.match_ticker.templates=_svs.widget.match_ticker.templates||{};
svs.widget.match_ticker.templates.match_score = Handlebars.template({"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    var stack1, alias1=container.lambda, alias2=container.escapeExpression, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "<p class=\"match-ticker-item__info-team-score\">"
    + alias2(alias1(((stack1 = (depth0 != null ? lookupProperty(depth0,"score") : depth0)) != null ? lookupProperty(stack1,"home") : stack1), depth0))
    + "</p>\n<p class=\"match-ticker-item__info-team-score\">"
    + alias2(alias1(((stack1 = (depth0 != null ? lookupProperty(depth0,"score") : depth0)) != null ? lookupProperty(stack1,"away") : stack1), depth0))
    + "</p>";
},"useData":true});
Handlebars.partials['widget-match_ticker-match_score'] = svs.widget.match_ticker.templates.match_score;
})(svs, Handlebars);


 })(window);